import { fragmentNavigate, includeElementsInURL } from "./boost.js";
import "./fragment.css";

export class FragmentElement extends HTMLElement {
    connectedCallback() {
        let src = this.getAttribute("src");
        if (!src) {
            return;
        }
        const include = this.getAttribute("include");
        if (include) {
            src = includeElementsInURL(include, src);
        }

        fragmentNavigate(this, src);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "bd-fragment": FragmentElement;
    }
}

customElements.define("bd-fragment", FragmentElement);
